var exports = {
  "kL": "x127c5a35--214071--container",
  "Qs": "x127c5a35--214071--content",
  "p_": "x127c5a35--214071--list",
};

module.exports = exports;
